import React from "react";
import OperateurDetail from "./OperateurDetail";

// « Ma structure » (CE-1407) : la fiche de l'opérateur du compte connecté,
// lue dans le jeton de session (`operateur`). L'onglet de l'adresse
// (/ma-structure/sites) s'ouvre à l'arrivée.
const MaStructure = (props) => <OperateurDetail {...props} vueOperateur />;

export default MaStructure;
